import { render, staticRenderFns } from "./ExamAsCollFromRegList.vue?vue&type=template&id=fc05be8a&scoped=true&"
import script from "./ExamAsCollFromRegList.vue?vue&type=script&lang=js&"
export * from "./ExamAsCollFromRegList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc05be8a",
  null
  
)

export default component.exports